const Style = () => ({
  search__bar: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    // padding: '1rem 1.2rem 0',
  },
  search__field: {
    background: '#F6F6F8',
    borderRadius: '100px',
    height: '42px',
    marginRight: '.7rem',
    '& .MuiInputBase-root': {
      height: '100%',
      padding: '0 1rem',
      '& input': {
        height: '100%',
        fontSize: '14px',
        fontWeight: '500',
        color: '#000',
        padding: '0',
      },
    },
  },
  clear__btn: {
    width: '110px',
    height: '42px',
    background: '#FFD9C8',
    color: 'var(--color-secondary)',
    fontSize: '13px',
    fontWeight: '600',
    borderRadius: '100px',
    '&:hover': {
      background: '#FFD9C8',
    },
    '& svg': {
      marginBottom: '4px',
      marginRight: '.3rem',
      '& path': {
        stroke: 'var(--color-secondary)',
      },
    },
  },
  disabled__btn: {
    color: 'rgba(109, 125, 139, 0.5)',
    background: 'rgba(109, 125, 139, 0.3)',
    '&:hover': {
      background: 'rgba(109, 125, 139, 0.3)',
    },
    '& svg': {
      '& path': {
        stroke: 'rgba(109, 125, 139, 0.5)',
      },
    },
  },
});
export default Style;
